<div class="backdrop" *ngIf="open" @fadeInOut (click)="onDismiss()"></div>

<div class="payment-sheet" *ngIf="open" @slideInOut (click)="$event.stopPropagation()">
    <h2 *ngIf="titleKey">{{ titleKey | translate }}</h2>

    <!-- Wide illustrated buttons. A tap is the choice — see `variant`. -->
    <ng-container *ngIf="variant === 'artwork'">
        <p *ngIf="subtitleKey">{{ subtitleKey | translate }}</p>

        <div class="methods">
            <button *ngFor="let option of options"
                type="button"
                class="method-button"
                [disabled]="busy"
                [style.background-image]="'url(' + iconFor(option.method) + ')'"
                (click)="onChoose(option)">
                <span>{{ option.labelKey | translate }}</span>
            </button>
        </div>
    </ng-container>

    <!-- Title-and-subtitle rows inside an elevated card, mirroring the delivery form's
         payment section. Selecting only highlights; the footer button commits. -->
    <ng-container *ngIf="variant === 'rows'">
        <div class="method-card">
            <label class="card-label" *ngIf="subtitleKey">{{ subtitleKey | translate }}</label>
            <hr *ngIf="subtitleKey">

            <div class="payment-rows">
                <button *ngFor="let option of options"
                    type="button"
                    class="payment-row"
                    [class.active]="selected === option.method"
                    [attr.aria-pressed]="selected === option.method"
                    [disabled]="busy"
                    (click)="onSelect(option)">
                    <span class="row-title">{{ option.labelKey | translate }}</span>
                    <span class="row-subtitle" *ngIf="option.subtitleKey">{{ option.subtitleKey | translate }}</span>
                </button>
            </div>
        </div>

        <!-- The caller's own content for the highlighted method — the tip picker while
             Online payment is. Between the choice and the button that commits it, so it
             reads as part of the choice. The sheet knows nothing about what it is. -->
        <ng-content></ng-content>

        <button type="button"
            class="confirm-button"
            [disabled]="busy || !selected"
            (click)="onConfirm()">
            {{ commitLabelKey | translate }}
        </button>
    </ng-container>

    <div class="drower"></div>
</div>
